import { Directive, HostListener } from "@angular/core";
import { NgControl } from "@angular/forms";

@Directive({
  selector: "[noWhiteSpaces]"
})
export class WhiteSpaceDirective {

  constructor(private ngControl: NgControl) {}

  @HostListener("blur")
  onBlur(): void {
    const value = this.ngControl.value;
    if (value) {
      this.ngControl.control.setValue(value.trim());
    }
  }
}
